import React from 'react';
import { Box, BoxExtendedProps } from '@common-fe/common-fe';

import { AccountOrder } from '@/modules/UseMyMoney/queries';
import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

import PaymentOrderBrick from './PaymentOrderBrick';

interface Props extends BoxExtendedProps {
  accountOrders?: OcrAccountOrderOption[] | AccountOrder[];
  isMobile?: boolean;
}

const ServicesPaymentOrder: React.FC<Props> = ({ accountOrders, isMobile }) => {
  return (
    <Box
      data-testId="services-payment-order_bricks-wrapper"
      pad={{ right: 'spacing24' }}
      style={{ position: 'relative' }}
      direction="row"
      wrap
    >
      {accountOrders?.map((account, index) => (
        <Box
          data-testId="services-payment-order_brick-wrapper"
          key={account?.accountId}
          margin={{ top: isMobile && index !== 0 ? undefined : 'spacing8' }}
          width={isMobile ? '100%' : undefined}
        >
          <PaymentOrderBrick
            zIndex={accountOrders?.length - index}
            order={index + 1}
            account={account}
            isMobile={isMobile}
            isSmall
          />
        </Box>
      ))}
    </Box>
  );
};

export default ServicesPaymentOrder;
